module.exports = __webpack_public_path__ + "files/78cd3128ae0b383f788075860f6d59c2.png";